module.exports = __webpack_public_path__ + "img/b2.edc133aa.webp";